export function getReviewerInitial(name = "") {
  const trimmed = String(name).trim();
  if (!trimmed) return "?";
  return trimmed.charAt(0).toUpperCase();
}

export function formatReviewDateRelative(dateStr) {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "";

  const diffMs = Date.now() - date.getTime();
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (days < 1) return "Today";
  if (days === 1) return "1 Day Ago";
  if (days < 7) return `${days} Days Ago`;
  if (days < 14) return "1 Week Ago";
  if (days < 30) return `${Math.floor(days / 7)} Weeks Ago`;
  if (days < 60) return "1 Month Ago";
  return `${Math.floor(days / 30)} Months Ago`;
}

export function formatReviewDateFull(dateStr) {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatSlugLabel(slug) {
  if (!slug) return "";
  return slug
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function formatCompactCount(value) {
  const count = Number(value) || 0;
  if (count >= 1000) {
    const compact = count / 1000;
    return Number.isInteger(compact) ? `${compact}k` : `${compact.toFixed(1)}k`;
  }
  return String(count);
}

export function getRatingBreakdownRows(ratingsBreakdown = {}, totalRatings = 0) {
  return [5, 4, 3, 2, 1].map((star) => {
    const count =
      Number(ratingsBreakdown[`${star}.0`]) ||
      Number(ratingsBreakdown[String(star)]) ||
      0;
    const percent = totalRatings > 0 ? (count / totalRatings) * 100 : 0;

    return { star, count, percent };
  });
}

export function getReviewImageSrc(image) {
  if (!image) return "";
  if (typeof image === "string") return image.trim();
  return String(
    image.imagePath ||
      image.imageUrl ||
      image.url ||
      image.path ||
      image.src ||
      ""
  ).trim();
}

export function collectTravelerGalleryImages(reviews = [], limit = 20) {
  const images = [];

  reviews.forEach((review) => {
    (review.reviewImages || review.images || []).forEach((image) => {
      const src = getReviewImageSrc(image);
      if (src && !images.includes(src)) {
        images.push(src);
      }
    });
  });

  return Number.isFinite(limit) ? images.slice(0, limit) : images;
}
